import src from "IMAGE";
export default { src, width: 209, height: 64, blurWidth: 0, blurHeight: 0};
